import { render, staticRenderFns } from "./takegoods.vue?vue&type=template&id=67a4536c&"
import script from "./takegoods.vue?vue&type=script&lang=js&"
export * from "./takegoods.vue?vue&type=script&lang=js&"
import style0 from "./takegoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports